"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLogout = void 0;
var _reactRedux = require("react-redux");
/**
 * Deletes the user's session cookie and scrubs all browser stored user data.
 */
const useLogout = _ref => {
  let {
    oauthApi,
    resetUserData,
    usersApi
  } = _ref;
  const dispatch = (0, _reactRedux.useDispatch)();
  const [oauthLogout] = oauthApi.useLogoutMutation();
  const logout = () => oauthLogout().then(() => {
    dispatch(usersApi.util.resetApiState());
    dispatch(resetUserData());
  });
  return [logout];
};
exports.useLogout = useLogout;